<template>
  <div id="why-us" class="bg-gray-100 -my-20 mb-0">
    <div class="pt-48 pb-20 container">

      <div class="relative inline-block">
        <h6 class="text-secondary-500">
          - Why carry out your semen assessment with us?
        </h6>

        <h2 class="mt-4 max-w-screen-sm">
          Certified clinical embryologists with extensive experience in reproductive health.
        </h2>
      </div>

      <div class="grid sm:grid-cols-1 lg:grid-cols-2 gap-4 mt-10">

        <div class="rounded p-6 flex bg-white">
          <span class="text-navy-300 mr-4">
            01
          </span>
          <p>
            Our service is fast and efficient. Receive your semen assessment results on the same day as your appointment. Get Saturday appointments that suit your schedule.
          </p>
        </div>

        <div class="rounded p-6 flex bg-white">
          <span class="text-navy-300 mr-4">
            02
          </span>
          <p>
            Our staff are extremely professional and discreet. Feel safe and informed throughout the process with them.
          </p>
        </div>

        <div class="rounded p-6 flex bg-white">
          <span class="text-navy-300 mr-4">
            03
          </span>
          <p>
            Our scientists are highly trained and have years of experience working in IVF clinics. Benefit from this, every step of the way.
          </p>
        </div>

        <div class="rounded p-6 flex bg-white">
          <span class="text-navy-300 mr-4">
            04
          </span>
          <p>
            We welcome all clients, including GP and Self referrals.
          </p>
        </div>

        <div class="rounded p-6 flex bg-white">
          <span class="text-navy-300 mr-4">
            05
          </span>
          <p>
            We offer flexibility. Produce your semen sample in the safety and privacy of your own home or on-site in the clinic. The choice is yours.
          </p>
        </div>

        <div class="rounded p-6 flex bg-white">
          <span class="text-navy-300 mr-4">
            06
          </span>
          <p>
          Our location ensures easy access from the surrounding areas of Dublin, Wexford, Wicklow and Carlow.<br><br>
          For those travelling from further afield it is an opportunity to take a break away and enjoy what the east coast has to offer.<br>
          <a href="www.lovegorey.ie" class="text-primary-500" target="_blank">lovegorey.ie</a>
          </p>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'WhySection'
}
</script>
